/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Icon, IconNames, Row } from "..";
import { COLORS } from "../../shared/theme";

export const GlobalSearch: React.FC<{
  value: string;
  onChange: (value: string) => void;
  onEnter: () => void;
  onEsc: () => void;
}> = ({ value, onChange, onEnter, onEsc }) => (
  <div
    css={css`
      position: relative;
      width: 100%;
    `}
  >
    <Icon
      name={IconNames.Search}
      size={25}
      css={css`
        transform: translateY(-50%);
        position: absolute;
        top: 50%;
        left: 5px;
      `}
    />
    <input
      type="text"
      placeholder="Search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Escape" || e.key === "Esc")
          if (value.length > 0) {
            onChange("");
            onEsc();
          } else (e.target as HTMLElement).blur();
        if (e.key === "Enter") onEnter();
      }}
      css={css`
        width: 100%;
        height: 35px;
        padding: 0 65px 0 35px;
        outline: none;
        border: none;
        border-radius: 10px;
        background-color: #f6f6f9;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: -0.02em;

        &::placeholder {
          color: ${COLORS.SILVER};
        }
      `}
    />
    {value.length > 0 && (
      <Row
        gap={5}
        css={css`
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          right: 5px;
        `}
      >
        <Icon
          name={IconNames.Enter}
          role="button"
          css={css`
            cursor: pointer;
          `}
          onClick={onEnter}
        />
        <Icon
          name={IconNames.X}
          role="button"
          onClick={() => {
            onChange("");
            onEsc();
          }}
          css={css`
            cursor: pointer;
          `}
        />
      </Row>
    )}
  </div>
);
